import { motion } from "framer-motion";

const AuthProgress = ({ currentStep = 1, totalSteps = 4 }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-[0.28em] text-slate-500">
        <span>Account Setup</span>
        <span>
          Step {currentStep} of {totalSteps}
        </span>
      </div>
      <div className="flex items-center gap-2">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber <= currentStep;

          return (
            <div key={stepNumber} className="flex flex-1 items-center gap-2">
              <motion.div
                initial={false}
                animate={{
                  scale: isActive ? 1 : 0.92,
                  backgroundColor: isActive ? "#f97316" : "#e2e8f0",
                }}
                className="h-4 w-4 rounded-full shadow-sm"
              />
              {stepNumber < totalSteps && (
                <motion.div
                  initial={false}
                  animate={{
                    backgroundColor: stepNumber < currentStep ? "#f97316" : "#cbd5e1",
                  }}
                  className="h-1 flex-1 rounded-full"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AuthProgress;
